import LandSelectENSPage from './LandSelectENSPage.container'
export default LandSelectENSPage
